import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { View } from '@technocom/common';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { filter, map, mergeMap } from 'rxjs/operators';
import { MainMenuService } from '@technocom/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent extends View implements OnInit {
  constructor(
    private menu: MainMenuService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: Title,
  ) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.handleTitle();
  }

  private handleTitle() {
    const initialTitle = this.titleService.getTitle();
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        map(() => this.activatedRoute),
        map(route => {
          while (route.firstChild) route = route.firstChild;
          return route;
        }),
        filter(route => route.outlet === 'primary'),
        mergeMap(route => route.data),
      )
      .subscribe((data: { dataObject: { headline: string } }) => {
        const lastLinkPart = this.router.url.slice(1).split('/').reverse()[0];
        const menuZone = this.menu.getNode(lastLinkPart)?.text;
        this.titleService.setTitle(data.dataObject?.headline || menuZone || initialTitle);
      });
  }
}
